import { combine } from '../../shared/utilities/route';
import { AppSettings } from '../../config/app-settings';

export class MarginCalculatorBaseService {
    get coreApiPath(): string {
        return combine(AppSettings.coreAPIUrl, 'ayanova');
    }
}
